export default function getOrgUsersByOrgId(state, id) {
  const { isOrgUsersLoaded, users } = state.orgUsers;

  if (id && isOrgUsersLoaded) {
    return users.filter(user => user.orgId === id);
  }

  return [];
}
